import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@nerdwallet/currency';
import PlayButtonDefaultIcon from './assets/play-button-default-image';

import './youtube-player.less';

const defaultDimensions = {
  height: '232px',
  width: '100%',
};

const YouTubePlayer = ({
  videoSlug,
  width = defaultDimensions.width,
  height = defaultDimensions.height,
  imagePlaceholder = '',
  playButtonImage = '',
}) => {
  const src = `https://www.youtube.com/embed/${videoSlug}?autoplay=1`;
  const [showPlayer, setShowPlayer] = useState(false);

  const handleLoadPlayer = () => {
    setShowPlayer(true);
  };

  return (
    <Box
      id="you-tube-player-container"
      onClick={handleLoadPlayer}
      style={{
        backgroundImage: showPlayer ? 'none' : `url(${imagePlaceholder})`,
        maxHeight: height || defaultDimensions.height,
        width,
      }}
      className="video-placeholder"
    >
      {showPlayer ? (
        <iframe
          title="video embed"
          id="youtube-iframe"
          type="text/html"
          width="100%"
          height="100%"
          src={src}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      ) : (
        <React.Fragment>
          {playButtonImage ? (
            <img
              id="default-player-btn"
              src={playButtonImage}
              alt="Play Button"
            />
          ) : (
            <PlayButtonDefaultIcon />
          )}
        </React.Fragment>
      )}
    </Box>
  );
};

YouTubePlayer.propTypes = {
  videoSlug: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  playButtonImage: PropTypes.string,
  imagePlaceholder: PropTypes.string,
};

export default YouTubePlayer;
